import { useEffect, useState } from 'react';
import {
  AgxControlledCheckbox,
  AgxCurrency,
  AgxRow,
} from '@urbanx/agx-ui-components';
import '../MarketingPackages.scss';

interface AgentToFillItemProps {
  id: string;
  productName: string;
  pricePerUnit?: number;
  selected: boolean;
  validate?: boolean;
  onSelectProductChange: (value: {
    id: string;
    productName: string;
    pricePerUnit?: number;
    value: boolean;
  }) => void;
}

const AgentToFillItem = ({
  id,
  productName,
  pricePerUnit,
  selected,
  validate,
  onSelectProductChange,
}: AgentToFillItemProps) => {
  const [agentPrice, setAgentPrice] = useState(pricePerUnit);
  const [productSelected, setProductSelected] = useState(selected);

  useEffect(() => {
    setProductSelected(selected);
  }, [selected]);

  useEffect(() => {
    const number = Number(agentPrice);

    onSelectProductChange({
      id,
      productName,
      pricePerUnit: !Number.isNaN(agentPrice)
        ? number <= 0 || !number
          ? 0
          : number
        : 0,
      value: productSelected,
    });
  }, [agentPrice, productSelected]);

  const onValueChanged = (value: boolean) => {
    setProductSelected(value === true);
  };

  const onInputValueChange = ({ value }: { value: string | null }) => {
    const newValue = value?.toString()?.replace(/,/g, '');
    setAgentPrice(newValue ? Number(newValue) : undefined);
  };

  const validateAgentPrice =
    validate &&
    productSelected &&
    (agentPrice === null || agentPrice === undefined);

  return (
    <AgxRow
      fill
      spaceBetween
      centered
      mediumGap
      extraClasses="marketingPackageItem"
    >
      <AgxControlledCheckbox
        naked
        label={productName}
        checked={productSelected}
        onValueChanged={onValueChanged}
        id={id}
      />
      <AgxCurrency
        id={`marketingpackage-item-text-${productName}-${id}`}
        required
        defaultValue={
          agentPrice === null || agentPrice === undefined
            ? ''
            : agentPrice?.toString()
        }
        onInputValueChange={onInputValueChange}
        decimalPoints={2}
        formatDecimalsOnBlur
        small
        placeholder="0.00"
        alignRight
        extraClasses={`agentToFillCurrency ${validateAgentPrice && 'error'}`}
        displayErrors={validateAgentPrice}
        error={validateAgentPrice ? 'Enter price' : undefined}
        validate={validateAgentPrice}
      />
    </AgxRow>
  );
};

export default AgentToFillItem;
